import { render, staticRenderFns } from "./deleteReportCustomComponentFooter.vue?vue&type=template&id=451b30a3"
import script from "./deleteReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./deleteReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports